module.exports = __webpack_public_path__ + "media/theme/in stock-bd790060.svg";